namespace RedBullMOBILE360.Membership {

    @Serenity.Decorators.registerClass()
    export class ForgotPasswordPanel extends Serenity.PropertyPanel<ForgotPasswordRequest, any> {

        protected getFormKey() { return ForgotPasswordForm.formKey; }

        private form: ForgotPasswordForm;

        constructor(container: JQuery) {
            super(container);

            $.fn['vegas'] && $('body')['vegas']({
                delay: 30000,
                cover: true,
                overlay: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAA3NCSVQICAjb4U" +
                    "/gAAAABlBMVEX///8AAABVwtN+AAAAAnRSTlMA/1uRIrUAAAAJcEhZcwAAAsQAAALEAVuRnQsAAAAWdEVYdENyZWF0" +
                    "aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAAxJREFUCJljaGBgAAABhACBrONIPgAAAABJRU5ErkJggg==",
                slides: [
                    { src: Q.resolveUrl("~/Content/site/images/slides/1.png"), transition: 'fade' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/2.png"), transition: 'zoomOut' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/3.png"), transition: 'swirlLeft' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/4.png"), transition: 'fade' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/5.png"), transition: 'zoomOut' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/6.png"), transition: 'swirlLeft' },
                    { src: Q.resolveUrl("~/Content/site/images/slides/7.png"), transition: 'fade' },
                ]
            });

            this.form = new ForgotPasswordForm(this.idPrefix);

            this.byId('SubmitButton').click(e => {
                e.preventDefault();

                if (!this.validateForm()) {
                    return;
                }

                var request = this.getSaveEntity();
                Q.serviceCall({
                    url: Q.resolveUrl('~/Account/ForgotPassword'),
                    request: request,
                    onSuccess: response => {
                        Q.information(Q.text('Forms.Membership.ForgotPassword.Success'), () => {
                            window.location.href = Q.resolveUrl('~/');
                        });
                    }
                });
            });
        }
    }
}